import './dynamic-imports';

import {setCookie, getCookie, deleteCookie} from './helpers';
import {scrollToElement} from './helpers';

window.setCookie = setCookie;
window.getCookie = getCookie;
window.deleteCookie = deleteCookie;
window.scrollToElement = scrollToElement;
